<template>
<div class="container">  
  <div class="row justify-content-center">      
    <div class="col-md-12 col-lg-8 col-12 mt-3">            
      <div class="sumilla my-5">
        <div class=""></div>
          <div class="sumilla-content">
            <h2 v-html="cardText.text"></h2>
          </div>
        </div>
    </div>
  </div>    
</div> 
</template>

<script>  
export default {
  name: 'SingleCard',
  props: {
    cardText: Object
  }

}
</script>